import { IEnvironment } from 'interfaces-lib';
import { StorageType } from 'storage-service-lib';
import { buildVersion } from './build.version';

export const environment: Partial<IEnvironment> = {
  appName: 'adv2-word-addin',
  name: 'dev',
  featureFlagsUrl: 'https://platform-dev.kyloe.io/feature-flags/api/v1/client-init',
  featureFlagsApiKey: 'Kv5tiKDe4i8O7jFYZz5wNawc3d3hqJ8L7KlKXTRa',
  kpHost: 'https://backend-dev.awesome-docs.io',
  uiHost: 'https://word-add-in-dev.awesome-docs.io',
  managerUrl: 'https://manager-dev.awesome-docs.io',
  production: false,
  version: buildVersion + '-DEV',
  isDev: true,
  identityStorageType: StorageType.LOCAL,

  // AI Assist API Config
  aiAssistApiUrl: 'https://ai-assist-api.kyloe.plus/dev',
  aiAssistApiKey: 'nKks0HMmW37nqziQQR0LZ2RZLpUlXUxK1ACj76O8',

  // adv2 datatooolsAdmin API
  adApiGatewayUrl: 'https://api-datatoolsadmin.kyloe.plus/stephen-dev',
  adApiGatewayKey: 'PbFTLDLVTF1JateBwg0TG4KxU7hZvzJKzzykQqQh',

  enableAnalytics: false,

  // AWS RUM Config
  awsRum: {
    endpoint: '',
    guestRoleArn: '',
    identityPoolId: '',
    APPLICATION_ID: '',
    APPLICATION_REGION: '',
  },

  // Google Analytics Config
  googleAnalytics: 'G-9NSBX9RY7W',

  // Pendo
  pendoAPIKey: '954627be-ab86-42f7-7079-6f153f272bbb',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
